<script lang="ts">
	import type { EligibleProductsResponse } from '$lib/types/special-sale';
	import type { ProductCardMissingInfo$result } from '$houdini';
	import { getTranslate } from '@tolgee/svelte';
	import { mapToNode } from '$lib/utils/product';
	import ProductBundleRecommendationCard from '$lib/components/Product/SpecialSale/ProductBundleRecommendationCard.svelte';
	import { cart } from '$lib/store/cart.store';
	import ButtonSecondary from '$lib/components/Button/ButtonSecondary.svelte';
	import { recordAddToCart } from '$lib/posthog';

	export let sale: EligibleProductsResponse;
	export let productData: ProductCardMissingInfo$result;
	const { t } = getTranslate();

	let sku: string | undefined;
	let hasCompletedSelection = productData.product?.is_single?.value === 'true';
	$: selectedVariant = mapToNode(productData.product?.variants).find((s) => s.sku?.value === sku);
	$: sdsVariant = mapToNode(productData.sdsProduct?.variants).find((s) => s.sku?.value === sku);
</script>

{#if productData?.product}
	<div class="flex flex-col w-full lg:w-1/2 flex-none snap-start gap-6">
		<ProductBundleRecommendationCard
			data={productData}
			discountedPercentage={sale.discountPercentage}
			bind:sku
			on:complete={() => (hasCompletedSelection = true)}
			on:incomplete={() => (hasCompletedSelection = false)}
		/>

		<ButtonSecondary
			on:click={async () => {
				if (!selectedVariant?.id || !selectedVariant?.sku?.value || !sdsVariant) {
					return;
				}
				recordAddToCart({
					sku: selectedVariant?.sku?.value || '',
					source: 'Cart Bundle Recommendation',
					quantity: 1,
					handle: productData?.product?.handle || ''
				});
				await cart.addSDSItem({
					sku: selectedVariant.sku?.value || '',
					variantId: selectedVariant.id,
					sdsId: sdsVariant.id,
					sdsThreshold: Number(selectedVariant.sds_qty?.value || '10') || 10,
					quantity: 1,
					handle: productData?.product?.handle || '',
					sdsOnHand: sdsVariant.quantityAvailable || 0,
					avantradoOnHand: selectedVariant.quantityAvailable || 0
				});
			}}
			disabled={!sku || !hasCompletedSelection}
			text={$t('cart.lines.add')}
		/>
	</div>
{/if}
